const firstJob = {
  first: [
    {
      skills:
        "Representative/ Agent of the shipowners front of the local authorities.",
      key: "list-one"
    },
    {
      skills: "Responsible for the ship's crew as it berthed at the port",
      key: "list-two"
    },
    {
      skills:
        "Responsible for coordination of all ship arrival and departure procedure from the country.",
      key: "list-three"
    },
    {
      skills:
        "A very wide area that requires huge responsibility and availability of 24/7",
      key: "list-four"
    }
  ],
  second: [
    {
      skills: "Owners of 3 businesses",
      key: "2list-one"
    },
    {
      skills: "Employed and managed about 20 employees.",
      key: "2list-two"
    }
  ]
};

export default firstJob;
